import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faCheckCircle, 
  faTimesCircle,
  faUserPlus,
  faStar
} from '@fortawesome/free-solid-svg-icons';

const FacilitatorCard = ({ facilitator, onRequestMatch }) => {
  const { user, bio, specializations, active_matches_count, max_active_matches, is_available } = facilitator;

  const capacityPercentage = (active_matches_count / max_active_matches) * 100;

  return (
    <div style={{
      backgroundColor: '#000',
      border: '1px solid #333',
      borderRadius: '12px',
      padding: '1.5rem',
      transition: 'all 0.3s',
      cursor: 'pointer',
      position: 'relative',
      overflow: 'hidden'
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.border = '1px solid #FFB6C1';
      e.currentTarget.style.transform = 'translateY(-4px)';
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.border = '1px solid #333';
      e.currentTarget.style.transform = 'translateY(0)';
    }}
    >
      {/* Availability Badge */}
      <div style={{
        position: 'absolute',
        top: '1rem',
        right: '1rem',
        padding: '0.25rem 0.75rem',
        borderRadius: '20px',
        fontSize: '0.75rem',
        fontWeight: '600',
        backgroundColor: is_available ? '#10b98120' : '#ef444420',
        color: is_available ? '#10b981' : '#ef4444',
        border: `1px solid ${is_available ? '#10b981' : '#ef4444'}`
      }}>
        <FontAwesomeIcon icon={is_available ? faCheckCircle : faTimesCircle} />
        {' '}
        {is_available ? 'Available' : 'At Capacity'}
      </div>

      {/* Facilitator Info */}
      <div style={{ marginBottom: '1rem' }}>
        {/* Avatar Placeholder */}
        <div style={{
          width: '80px',
          height: '80px',
          borderRadius: '50%',
          backgroundColor: '#FFB6C1',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '2rem',
          fontWeight: '700',
          color: '#000',
          marginBottom: '1rem'
        }}>
          {user?.full_name?.charAt(0)?.toUpperCase() || '?'}
        </div>

        <h3 style={{ 
          color: '#FFB6C1', 
          marginBottom: '0.5rem',
          fontSize: '1.3rem',
          fontWeight: '600'
        }}>
          {user?.full_name || 'Unknown'}
        </h3>

        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.25rem',
          marginBottom: '0.5rem',
          color: '#fbbf24'
        }}>
          <FontAwesomeIcon icon={faStar} />
          <FontAwesomeIcon icon={faStar} />
          <FontAwesomeIcon icon={faStar} />
          <FontAwesomeIcon icon={faStar} />
          <FontAwesomeIcon icon={faStar} style={{ color: '#666' }} />
          <span style={{ color: '#999', fontSize: '0.9rem', marginLeft: '0.5rem' }}>
            (4.0)
          </span>
        </div>
      </div>

      {/* Bio */}
      <p style={{ 
        color: '#ccc', 
        marginBottom: '1rem',
        fontSize: '0.95rem',
        lineHeight: '1.5',
        minHeight: '60px'
      }}>
        {bio || 'Experienced facilitator ready to help you on your wellbeing journey.'}
      </p>

      {/* Specializations */}
      {specializations && specializations.length > 0 && (
        <div style={{ marginBottom: '1rem' }}>
          <div style={{ 
            display: 'flex', 
            flexWrap: 'wrap', 
            gap: '0.5rem' 
          }}>
            {specializations.map((spec, index) => (
              <span
                key={index}
                style={{
                  padding: '0.25rem 0.75rem',
                  backgroundColor: '#1a1a1a',
                  border: '1px solid #FFB6C1',
                  borderRadius: '20px',
                  fontSize: '0.85rem',
                  color: '#FFB6C1'
                }}
              >
                {spec}
              </span>
            ))}
          </div>
        </div>
      )}

      {/* Capacity Bar */}
      <div style={{ marginBottom: '1rem' }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginBottom: '0.5rem',
          fontSize: '0.85rem',
          color: '#999'
        }}>
          <span>Capacity</span>
          <span>{active_matches_count} / {max_active_matches}</span>
        </div>
        <div style={{
          width: '100%',
          height: '8px',
          backgroundColor: '#1a1a1a',
          borderRadius: '4px',
          overflow: 'hidden'
        }}>
          <div style={{
            width: `${capacityPercentage}%`,
            height: '100%',
            backgroundColor: capacityPercentage >= 100 ? '#ef4444' : 
                           capacityPercentage >= 80 ? '#fbbf24' : '#10b981',
            transition: 'width 0.3s'
          }} />
        </div>
      </div>

      {/* Request Button */}
      <button
        onClick={() => onRequestMatch(facilitator)}
        disabled={!is_available}
        style={{
          width: '100%',
          padding: '0.75rem',
          backgroundColor: is_available ? '#FFB6C1' : '#333',
          border: 'none',
          borderRadius: '8px',
          color: is_available ? '#000' : '#666',
          fontSize: '1rem',
          fontWeight: '600',
          cursor: is_available ? 'pointer' : 'not-allowed',
          transition: 'all 0.3s'
        }}
        onMouseEnter={(e) => {
          if (is_available) {
            e.currentTarget.style.backgroundColor = '#ff9eb5';
          }
        }}
        onMouseLeave={(e) => {
          if (is_available) {
            e.currentTarget.style.backgroundColor = '#FFB6C1';
          }
        }}
      >
        <FontAwesomeIcon icon={faUserPlus} /> Request Match
      </button>
    </div>
  );
};

export default FacilitatorCard;
